import React from "react";
import Sidebar from "../../../components/Sidebar";
import PageHeader from "../../../components/PageHeader";
import TableHeader from "../../../components/TableHeader";
import {Bar, Line} from "react-chartjs-2";
import moment from "moment";
import DatePicker, {registerLocale} from "react-datepicker";
import vi from "date-fns/locale/vi";
import QltsReportController from "../../../services/qlts/qlts-report-controller";
import {getSchoolYear} from "../../../utils/authority";
import {toast} from "react-toastify";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
registerLocale("vi", vi);

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDate: new Date(new Date().valueOf()-2592000000),
            toDate: new Date(),
            listReportState: [],
            totalReportState: 1,

            listReportCampaign: [],
            totalReportCampaign: 1,

            listReportResource: [],
            totalReportResource: 1,

            listSales: [],
            saleName: "",
            saleId: -1,
            listReportSale: [],
            totalReportSale: 1,

            pageNumber: 0,
            pageSize: 10,
            sort: "created_at desc",

            monthSales: new Date().getMonth() + 1,
            monthPartner: new Date().getMonth() + 1,
            listPartnerId: [],
            dataDashboardPartner: [],
            dataPartnerByMonth: [],
            dataAccumulated: [],
            dataAccumulatedToNow: [],
            dataContractOrder: [],
            dataSales: [],
            dataSalesYear: [],
            dataSalesByMonth: {},
            monthSupAcc: [],
            showLoading: false,
            labelsSup: [],
            labelsAcc: [],
            dataSup: [],
            dataAcc: [],
            monthRevenue: [],
            dataRevenue: [],
            orderData: null,

            header1: [
                {
                    id: 'stt',
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'status',
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'time',
                    name: "Khoảng thời gian",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'number',
                    name: "Số lượng",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'percent',
                    name: "Tỷ lệ(%)",
                    style: {textAlign: "center"},
                    sort: false,
                }
            ],
            header2: [
                {
                    id: 'stt',
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'status',
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'time',
                    name: "Khoảng thời gian",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'number',
                    name: "Số lượng",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'percent',
                    name: "Tỷ lệ(%)",
                    style: {textAlign: "center"},
                    sort: false,
                }
            ],

            header3: [
                {
                    id: 'stt',
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'name',
                    name: "Tên",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'time',
                    name: "Khoảng thời gian",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'source',
                    name: "Nguồn",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'number',
                    name: "Số lượng",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'percent',
                    name: "Tỷ lệ(%)",
                    style: {textAlign: "center"},
                    sort: false,
                },
            ],
            headerSale: [
                {
                    id: 'stt',
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'status',
                    name: "Tên",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'total',
                    name: "Tổng khách",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'time',
                    name: "Mới",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'PEOPLE_IN_CHARGE',
                    name: "Đang chăm sóc",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'number',
                    name: "Tiềm năng",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'percent',
                    name: "Hẹn gặp",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'REGISTERED',
                    name: "Đã đăng ký",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'PROFILED',
                    name: "Hoàn thành giữ chỗ",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'BOOKED',
                    name: "Đã nhập học",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'CONSIDER',
                    name: "Xem xét",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'REJECT',
                    name: "Từ chối",
                    style: {textAlign: "center"},
                    sort: false,
                }
            ],
        }
    }
    getListReportState() {
        let payload = {
            from: moment(this.state.fromDate).format("YYYY-MM-DD HH:mm:ss"),
            to: moment(this.state.toDate).format("YYYY-MM-DD HH:mm:ss")
        };
        QltsReportController.getListReportState(payload,res => {
            if (res.success  && res.data != null) {
                this.setState(
                    {
                        listReportState: res.data?.list,
                        totalReportState: res.data?.total == 0? 1: res.data?.total
                    }
                );
            } else {
            }
        });
    }
    getListReportResource() {
        let payload = {
            from: moment(this.state.fromDate).format("YYYY-MM-DD HH:mm:ss"),
            to: moment(this.state.toDate).format("YYYY-MM-DD HH:mm:ss")
        };
        QltsReportController.getListReportResource(payload,res => {
            if (res.success && res.data != null) {
                this.setState(
                    {
                        listReportResource: res.data?.list,
                        totalReportResource: res.data?.total == 0? 1: res.data?.total
                    }
                );
            } else {

            }
        });
    }
    getListReportCampaign() {
        let payload = {
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: this.state.sort,
            yearId: parseInt(getSchoolYear()),
            from: moment(this.state.fromDate).format("YYYY-MM-DD HH:mm:ss"),
            to: moment(this.state.toDate).format("YYYY-MM-DD HH:mm:ss")
        };
        QltsReportController.getListReportCampaign(payload,res => {
            if (res.success && res.data != null) {
                this.setState(
                    {
                        listReportCampaign: res.data?.list,
                        totalReportCampaign: res.data?.total == 0? 1: res.data?.total
                    }
                );
            } else {
                toast.error("Có lỗi xảy ra: ", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        });
    }
    getListReportSale() {
        let payload = {
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: this.state.sort,
            from: moment(this.state.fromDate).format("YYYY-MM-DD HH:mm:ss"),
            to: moment(this.state.toDate).format("YYYY-MM-DD HH:mm:ss")
        };
        QltsReportController.getListReportSale(payload,res => {
            this.setState(
                {
                    listReportSale: res.content,
                    totalReportSale: res.totalElements == 0? 1: res.totalElements
                }
            );
        });
    }
    onhandleSearch() {
        if (this.state.saleId > -1){
            let payload = {
                saleId: this.state.saleId,
                pageNumber: this.state.pageNumber,
                pageSize: this.state.pageSize,
                sort: this.state.sort,
                from: moment(this.state.fromDate).format("YYYY-MM-DD HH:mm:ss"),
                to: moment(this.state.toDate).format("YYYY-MM-DD HH:mm:ss")
            };
            QltsReportController.getListReportDetailSale(payload,res => {
                this.setState(
                    {
                        listReportSale: [res.data],
                        totalReportSale: res.total == 0? 1: res.total
                    }
                );
            });
        }
    }
    getListSaleInCharge() {
        let payload = {
            username: this.state.saleName,
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: this.state.sort,
            from: moment(this.state.fromDate).format("YYYY-MM-DD HH:mm:ss"),
            to: moment(this.state.toDate).format("YYYY-MM-DD HH:mm:ss")
        };
        QltsReportController.getListReportSaleSearch(payload,res => {
            this.setState(
                {
                    listSales: res.content,
                    totalReportSale: res.totalElements == 0? 1: res.totalElements
                }
            );
            console.log(res.content)
        });
    }
    componentDidMount() {
        this.getListReportState();
        this.getListReportResource();
        this.getListReportCampaign();
        this.getListReportSale();
    }
    renderStatus = (status) => {
        switch (status) {
            case "NEW":
                return <h6><span className="badge bg-primary text-white">Mới</span></h6>;
            case "PEOPLE_IN_CHARGE":
                return <h6><span className="badge bg-info text-white">Đã phân công</span></h6>;
            case "POTENTIAL":
                return <h6><span className="badge badge-warning text-white">Tiềm năng</span></h6>;
            case "APPOINTMENT":
                return <h6><span className="badge badge-danger text-white">Hẹn gặp</span></h6>;
            case "REGISTERED":
                return <h6><span className="badge badge-pill text-black">Đã đăng ký</span></h6>;
            case "BOOKED":
                return <h6><span className="badge bg-success text-white">Hoàn thành giữ chỗ</span></h6>;
            case "PROFILED":
                return <h6><span className="badge bg-primary text-white">Đã nhập học</span></h6>;
            case "REJECT":
                return <h6><span className="badge bg-danger text-white">Từ chối</span></h6>;
            case "CONSIDER":
                return <h6><span className="badge bg-secondary text-white">Cân nhắc</span></h6>;
            default:
                return '';
        }
    };
    renderSale(status, listData){
        for(let i=0; i< listData.length; i++){
            if (listData[i].customerState == status){
                return  listData[i].quantity
            }
        }
        return 0
    };
    renderResource = (status) => {
        switch (status) {
            case "OTHER":
                return <h6><span className="badge badge-secondary text-white">Khác/Hội thảo</span></h6>;
            case "FACEBOOK":
                return <h6><span className="badge bg-primary text-white">Facebook</span></h6>;
            case "YOUTUBE":
                return <h6><span className="badge badge-danger text-white">Youtube</span></h6>;
            case "TIKTOK":
                return <h6><span className="badge badge-pill text-black">Tiktok</span></h6>;
            case "GOOGLE":
                return <h6><span className="badge bg-success text-white">Google</span></h6>;
            case "REF_PARENT":
                return <h6><span className="badge badge-warning text-white">Chia sẻ phụ huynh</span></h6>;
            case "REF_SALE":
                return <h6><span className="badge badge-info text-white">Từ sale</span></h6>;
            default:
                return '';
        }
    };
    render() {
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="report-admissions" parentClass="admissions-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Báo cáo tuyển sinh"/>
                                </div>
                                <div className="row w-100" style={{display: "none"}}>
                                    <div className="col-md-6 col-xs-12 pt-3 pb-3 pr-3 pl-F0">
                                        <div className="text-align-center">
                                            <span className="dashboard-title-item">[TUYỂN SINH] Nhân Sự</span>
                                        </div>
                                        <div className=" mb-3 widget-chart">
                                            <Bar
                                                data={{
                                                    // labels: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
                                                    labels: this.state.monthSupAcc,
                                                    datasets: [
                                                        {
                                                            label: 'Supervisor',
                                                            backgroundColor: 'rgba(75,192,192,0.4)',
                                                            borderColor: 'rgba(75,192,192,1)',
                                                            borderWidth: 1,
                                                            hoverBackgroundColor: 'rgba(75,192,192,1)',
                                                            hoverBorderColor: 'rgba(220,220,220,1)',
                                                            data: this.state.dataSup
                                                        },
                                                        {
                                                            label: 'Kế toán',
                                                            backgroundColor: 'rgba(255,99,132,0.2)',
                                                            borderColor: 'rgba(255,99,132,1)',
                                                            // backgroundColor: '#C6E6F1',
                                                            // borderColor: '#0075dd',
                                                            borderWidth: 1,
                                                            hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                                            hoverBorderColor: 'rgba(255,99,132,1)',
                                                            // hoverBackgroundColor: '#3ba5f7',
                                                            // hoverBorderColor: '#0075dd',
                                                            data: this.state.dataAcc
                                                        },
                                                    ]
                                                }}

                                                // width={100}
                                                height={350}
                                                options={{ maintainAspectRatio: false }}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xs-12 p-3">
                                        <div className="text-align-center">
                                            <span className="dashboard-title-item">[TUYỂN SINH] DOANH THU</span>
                                        </div>
                                        <Line ref="chart"
                                              data={{
                                                  labels: this.state.monthRevenue,
                                                  datasets: [
                                                      {
                                                          label: 'Doanh thu',
                                                          fill: false,
                                                          lineTension: 0.1,
                                                          // backgroundColor: 'rgba(75,192,192,0.4)',
                                                          // borderColor: 'rgba(75,192,192,1)',
                                                          backgroundColor: '#0075dd',
                                                          borderColor: '#0075dd',
                                                          borderCapStyle: 'butt',
                                                          borderDash: [],
                                                          borderDashOffset: 0.0,
                                                          borderJoinStyle: 'miter',
                                                          pointBorderColor: 'rgba(75,192,192,1)',
                                                          pointBackgroundColor: '#fff',
                                                          pointBorderWidth: 1,
                                                          pointHoverRadius: 5,
                                                          // pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                                                          // pointHoverBorderColor: 'rgba(220,220,220,1)',
                                                          pointHoverBackgroundColor: '#0075dd',
                                                          pointHoverBorderColor: '#0075dd',
                                                          pointHoverBorderWidth: 2,
                                                          pointRadius: 1,
                                                          pointHitRadius: 10,
                                                          data: this.state.dataRevenue
                                                          // data: [5000000,1000000,3000000]
                                                      }
                                                  ],
                                              }}
                                              height={250}
                                        />
                                    </div>
                                </div>
                                <div className="Trang thai">
                                    <label className='font-18'>Báo cáo theo Trạng Thái</label>
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-bordered table-admin-dashboard">
                                            <thead>
                                            <tr style={{backgroundColor: '#8bdaf6'}}>
                                                <th colSpan={2}>
                                                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                                                        Chọn thời gian
                                                    </div>
                                                </th>
                                                <th colSpan={3}>
                                                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                                                        <label className='mt-2 mr-2'>Từ</label>
                                                        <DatePicker
                                                            locale="vi"
                                                            className="w-auto  form-control kt-input pd-4-input hei-input"
                                                            selected={this.state.fromDate === '' ? null : new Date(this.state.fromDate)}
                                                            maxDate={new Date()}
                                                            dateFormat="dd-MM-yyyy"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            onChange={
                                                                (date) => {
                                                                    let value = moment(date).format("YYYY-MM-DD").toString();
                                                                    try {
                                                                        this.setState({
                                                                            fromDate: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                        }, () =>{
                                                                            this.getListReportState()
                                                                        })
                                                                    }catch (e) {

                                                                    }
                                                                }
                                                            }
                                                        />
                                                    </div>

                                                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                                                        <label className='mt-2 mr-2 ml-5'>Tới</label>
                                                        <DatePicker
                                                            locale="vi"
                                                            className="w-auto  form-control kt-input pd-4-input hei-input"
                                                            selected={this.state.toDate === '' ? null : new Date(this.state.toDate)}
                                                            maxDate={new Date()}
                                                            dateFormat="dd-MM-yyyy"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            onChange={
                                                                (date) => {
                                                                    let value = moment(date).format("YYYY-MM-DD").toString();
                                                                    try {
                                                                        this.setState({
                                                                            toDate: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                        }, () =>{
                                                                            this.getListReportState()
                                                                        })
                                                                    }catch (e) {

                                                                    }
                                                                }
                                                            }
                                                        />
                                                    </div>
                                                </th>
                                            </tr>
                                            <TableHeader header={this.state.header2}/>
                                            </thead>
                                            <tbody>
                                            {this.state.listReportState.map((item, index) => (
                                                <tr>
                                                    <th style={{textAlign: "center"}} scope="row">
                                                        {" "}
                                                        {index + 1}
                                                    </th>
                                                    <th className='text-center'> {this.renderStatus(item.customerState)}</th>
                                                    <th className='text-center'>{moment(this.state.fromDate).format("DD-MM-YYYY").toString()} --> {moment(this.state.toDate).format("DD-MM-YYYY").toString()}</th>
                                                    <th className='text-center'>{item.quantity}</th>
                                                    <th className='text-center'>{((item.quantity/this.state.totalReportState)*100).toFixed(0)}%</th>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="Sale">
                                    <label className='font-18'>Báo cáo theo Nhân Viên Sale</label>
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-bordered table-admin-dashboard">
                                            <thead>
                                            <tr style={{backgroundColor: '#8bdaf6'}}>
                                                <th colSpan={1}>
                                                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                                                        Tìm kiếm Sale
                                                    </div>
                                                </th>
                                                <th colSpan={3}>
                                                    <Autocomplete
                                                        size="small"
                                                        options={this.state.listSales}
                                                        getOptionLabel={option => option.fullName?option.fullName:"No Name"}
                                                        style={{width: '100%', background: "#fff"}}
                                                        inputValue={this.state.saleName}
                                                        renderInput={params => {
                                                            return <TextField
                                                                placeholder='Nhập tên/Tên đăng nhập'
                                                                {...params}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                    style: {
                                                                        fontSize: 17,
                                                                        backgroundColor: "#fff",
                                                                        paddingRight: 10,
                                                                        paddingLeft: 10,
                                                                        color: '#2e495c',
                                                                        fontWeight: 500,
                                                                        fontFamily: 'Montserrat'
                                                                    }
                                                                }}
                                                                label=""
                                                                variant="outlined"
                                                                fullWidth
                                                            />
                                                        }}
                                                        onInputChange={(event, val) => {
                                                            if (event !== null){
                                                                this.setState({
                                                                    saleName: val
                                                                }, ()=>{
                                                                    if (val.length> 0){
                                                                        this.getListSaleInCharge()
                                                                    }else {
                                                                        this.getListReportSale()
                                                                    }
                                                                })
                                                            }

                                                        }}
                                                        onChange={(e, val) => {
                                                            if (val?.id != undefined){
                                                                this.state.saleId = val?.id;
                                                                this.state.saleName = val?.fullName;
                                                                this.onhandleSearch()
                                                            }else {
                                                                this.state.saleName = "";
                                                            }
                                                        }}

                                                    />
                                                </th>

                                                <th colSpan={2}>
                                                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                                                        Chọn thời gian
                                                    </div>
                                                </th>
                                                <th colSpan={6}>
                                                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                                                        <label className='mt-2 mr-2'>Từ</label>
                                                        <DatePicker
                                                            locale="vi"
                                                            className="w-auto  form-control kt-input pd-4-input hei-input"
                                                            selected={this.state.fromDate === '' ? null : new Date(this.state.fromDate)}
                                                            maxDate={new Date()}
                                                            dateFormat="dd-MM-yyyy"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            onChange={
                                                                (date) => {
                                                                    let value = moment(date).format("YYYY-MM-DD").toString();
                                                                    try {
                                                                        this.setState({
                                                                            fromDate: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                        }, () =>{
                                                                            this.getListReportSale()
                                                                        })
                                                                    }catch (e) {

                                                                    }
                                                                }
                                                            }
                                                        />
                                                    </div>

                                                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                                                        <label className='mt-2 mr-2 ml-5'>Tới</label>
                                                        <DatePicker
                                                            locale="vi"
                                                            className="w-auto  form-control kt-input pd-4-input hei-input"
                                                            selected={this.state.toDate === '' ? null : new Date(this.state.toDate)}
                                                            maxDate={new Date()}
                                                            dateFormat="dd-MM-yyyy"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            onChange={
                                                                (date) => {
                                                                    let value = moment(date).format("YYYY-MM-DD").toString();
                                                                    try {
                                                                        this.setState({
                                                                            toDate: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                        }, () =>{
                                                                            this.getListReportSale()
                                                                        })
                                                                    }catch (e) {

                                                                    }
                                                                }
                                                            }
                                                        />
                                                    </div>
                                                </th>
                                            </tr>
                                            <TableHeader header={this.state.headerSale}/>
                                            </thead>
                                            <tbody>
                                            {this.state.listReportSale.map((item, index) => (
                                                <tr>
                                                    <th style={{textAlign: "center"}} scope="row">
                                                        {" "}
                                                        {index + 1}
                                                    </th>
                                                    <th className='text-center'> {item.userRes?.fullName}({item.userRes?.username})</th>
                                                    <th className='text-center'> {item.total}</th>
                                                    <th className='text-center'> {this.renderSale("NEW", item.list)}</th>
                                                    <th className='text-center'> {this.renderSale("PEOPLE_IN_CHARGE", item.list)}</th>
                                                    <th className='text-center'> {this.renderSale("POTENTIAL", item.list)}</th>
                                                    <th className='text-center'> {this.renderSale("APPOINTMENT", item.list)}</th>
                                                    <th className='text-center'> {this.renderSale("REGISTERED", item.list)}</th>
                                                    <th className='text-center'> {this.renderSale("BOOKED", item.list)}</th>
                                                    <th className='text-center'> {this.renderSale("PROFILED", item.list)}</th>
                                                    <th className='text-center'> {this.renderSale("CONSIDER", item.list)}</th>
                                                    <th className='text-center'> {this.renderSale("REJECT", item.list)}</th>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="Nguon">
                                    <label className='font-18'>Báo cáo theo Nguồn</label>
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-bordered table-admin-dashboard">
                                            <thead>
                                            <tr style={{backgroundColor: '#8bdaf6'}}>
                                                <th colSpan={2}>
                                                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                                                        Chọn thời gian
                                                    </div>
                                                </th>
                                                <th colSpan={3}>
                                                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                                                        <label className='mt-2 mr-2'>Từ</label>
                                                        <DatePicker
                                                            locale="vi"
                                                            className="w-auto  form-control kt-input pd-4-input hei-input"
                                                            selected={this.state.fromDate === '' ? null : new Date(this.state.fromDate)}
                                                            maxDate={new Date()}
                                                            dateFormat="dd-MM-yyyy"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            onChange={
                                                                (date) => {
                                                                    let value = moment(date).format("YYYY-MM-DD").toString();
                                                                    try {
                                                                        this.setState({
                                                                            fromDate: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                        }, () =>{
                                                                            this.getListReportResource()
                                                                        })
                                                                    }catch (e) {

                                                                    }
                                                                }
                                                            }
                                                        />
                                                    </div>

                                                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                                                        <label className='mt-2 mr-2 ml-5'>Tới</label>
                                                        <DatePicker
                                                            locale="vi"
                                                            className="w-auto  form-control kt-input pd-4-input hei-input"
                                                            selected={this.state.toDate === '' ? null : new Date(this.state.toDate)}
                                                            maxDate={new Date()}
                                                            dateFormat="dd-MM-yyyy"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            onChange={
                                                                (date) => {
                                                                    let value = moment(date).format("YYYY-MM-DD").toString();
                                                                    try {
                                                                        this.setState({
                                                                            toDate: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                        }, () =>{
                                                                            this.getListReportResource()
                                                                        })
                                                                    }catch (e) {

                                                                    }
                                                                }
                                                            }
                                                        />
                                                    </div>
                                                </th>
                                            </tr>
                                            <TableHeader header={this.state.header2}/>
                                            </thead>
                                            <tbody>
                                            {this.state.listReportResource.map((item, index) => (
                                                <tr>
                                                    <th style={{textAlign: "center"}} scope="row">
                                                        {" "}
                                                        {index + 1}
                                                    </th>
                                                    <th className='text-center'> {this.renderResource(item.customerSource)}</th>
                                                    <th className='text-center'>{moment(this.state.fromDate).format("DD-MM-YYYY").toString()} --> {moment(this.state.toDate).format("DD-MM-YYYY").toString()}</th>
                                                    <th className='text-center'>{item.quantity}</th>
                                                    <th className='text-center'>{((item.quantity/this.state.totalReportResource)*100).toFixed(0)}%</th>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="chien-dich">
                                    <label className='font-18'>Báo cáo theo Chiến dịch</label>
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-bordered table-admin-dashboard">
                                            <thead>
                                            <tr style={{backgroundColor: '#8bdaf6'}}>
                                                <th colSpan={2}>
                                                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                                                        Chọn thời gian
                                                    </div>
                                                </th>
                                                <th colSpan={6}>
                                                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                                                        <label className='mt-2 mr-2'>Từ</label>
                                                        <DatePicker
                                                            locale="vi"
                                                            className="w-auto  form-control kt-input pd-4-input hei-input"
                                                            selected={this.state.fromDate === '' ? null : new Date(this.state.fromDate)}
                                                            maxDate={new Date()}
                                                            dateFormat="dd-MM-yyyy"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            onChange={
                                                                (date) => {
                                                                    let value = moment(date).format("YYYY-MM-DD").toString();
                                                                    try {
                                                                        this.setState({
                                                                            fromDate: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                        }, () =>{
                                                                            this.getListReportCampaign()
                                                                        })
                                                                    }catch (e) {

                                                                    }
                                                                }
                                                            }
                                                        />
                                                    </div>

                                                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                                                        <label className='mt-2 mr-2 ml-5'>Tới</label>
                                                        <DatePicker
                                                            locale="vi"
                                                            className="w-auto  form-control kt-input pd-4-input hei-input"
                                                            selected={this.state.toDate === '' ? null : new Date(this.state.toDate)}
                                                            maxDate={new Date()}
                                                            dateFormat="dd-MM-yyyy"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            onChange={
                                                                (date) => {
                                                                    let value = moment(date).format("YYYY-MM-DD").toString();
                                                                    try {
                                                                        this.setState({
                                                                            toDate: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                        }, ()=>{
                                                                            this.getListReportCampaign()
                                                                        })
                                                                    }catch (e) {

                                                                    }
                                                                }
                                                            }
                                                        />
                                                    </div>
                                                </th>
                                            </tr>
                                            <TableHeader header={this.state.header3}/>
                                            </thead>
                                            <tbody>
                                            {this.state.listReportCampaign.map((item, index) => (
                                                <tr>
                                                    <th style={{textAlign: "center"}} scope="row">
                                                        {" "}
                                                        {index + 1}
                                                    </th>
                                                    <th className='text-center'> {item.name}</th>
                                                    <th className='text-center'>{moment(this.state.fromDate).format("DD-MM-YYYY").toString()} --> {moment(this.state.toDate).format("DD-MM-YYYY").toString()}</th>
                                                    <th className='text-center'>{item.quantity}</th>
                                                    <th className='text-center'> {this.renderResource(item.source)}</th>
                                                    <th className='text-center'>{((item.quantity/this.state.totalReportCampaign)*100).toFixed(0)}%</th>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default Dashboard
